import Verification from '../../../pages/dashboard/verification';

export const verification_routes_group = [
	{
		path: '/verification',
		element: Verification,
	},
];
